import { i18n } from "@/i18n";

export function useNumberFormat(value: number | undefined | null): string {
  return value ? i18n.n(value) : "";
}
